<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'attendanceHeading' | translate }}</h1>
      <p class="st-subtitle">{{ students.length }} {{ 'students' | translate }}</p>
    </div>
    <div class="scd-head-actions">
      <p-calendar [(ngModel)]="selectedDateObj" [ngModelOptions]="{standalone: true}" inputId="attendance-date"
        styleClass="scd-calendar" dateFormat="dd/mm/yy" [maxDate]="maxDate" [showIcon]="true" appendTo="body"
        (onSelect)="onDateChange()"></p-calendar>
      <button class="st-btn st-btn-primary" *ngIf="allowedToMarkAttendance"
        [disabled]="submitting || loading || !isChanged" (click)="requestSubmitAttendance()">
        <i class="ri-check-line"></i> {{ submitting ? ('savingEllipsis' | translate) : (attendanceTaken ? ('updateAttendance' | translate) : ('saveAttendance' | translate)) }}
      </button>
    </div>
  </div>

  <div class="st-tabs" *ngIf="isPeriodBased && periods.length">
    <div class="st-tab" *ngFor="let p of periods" [class.active]="selectedPeriodId === (p.periodId ?? p.id)" (click)="selectPeriod(p)">
      <ng-container *ngIf="p.name || p.periodName; else noPeriodName">{{ p.name || p.periodName }}</ng-container>
      <ng-template #noPeriodName>{{ 'periodLabel' | translate }} : {{ (p.periodId ?? p.id) ?? ('notAvailable' | translate) }}</ng-template>
    </div>
  </div>

  <div class="scd-bulk-actions" *ngIf="!loading && !loadError && students.length">
    <span class="scd-bulk-label">{{ 'markAllAs' | translate }}</span>
    <button class="st-btn st-btn-secondary scd-bulk-btn present" (click)="markAllAs('PRESENT')"><i class="ri-check-line"></i> {{ 'present' | translate }}</button>
    <button class="st-btn st-btn-secondary scd-bulk-btn absent" (click)="markAllAs('ABSENT')"><i class="ri-close-line"></i> {{ 'absent' | translate }}</button>
    <button class="st-btn st-btn-secondary scd-bulk-btn late" (click)="markAllAs('LATE')"><i class="ri-time-line"></i> {{ 'lateStatus' | translate }}</button>
  </div>

  <div class="st-card scd-attendance-list" *ngIf="loading">
    <div class="scd-attendance-row scd-skeleton-row" *ngFor="let s of skeletonPlaceholders">
      <div class="st-avatar scd-skeleton scd-skeleton-circle"></div>
      <div class="st-list-text">
        <div class="scd-skeleton scd-skeleton-line scd-skeleton-line-title"></div>
        <div class="scd-skeleton scd-skeleton-line scd-skeleton-line-sub"></div>
      </div>
      <div class="scd-status-btns">
        <div class="scd-skeleton scd-skeleton-status-btn"></div>
        <div class="scd-skeleton scd-skeleton-status-btn"></div>
        <div class="scd-skeleton scd-skeleton-status-btn"></div>
        <div class="scd-skeleton scd-skeleton-status-btn"></div>
      </div>
    </div>
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadStudentList' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && !loadError && students.length === 0">
    <i class="ri-group-line"></i> {{ 'noStudentsFoundForThisClass' | translate }}
  </div>

  <div class="st-card scd-attendance-list" *ngIf="!loading && !loadError && students.length">
    <ng-container *ngFor="let s of students; let i = index">
      <div class="scd-section-divider" *ngIf="sectionLabelBefore(i) as label">
        <span>{{ label | translate }}</span>
      </div>
      <div class="scd-attendance-row">
        <div class="st-avatar">
          <img *ngIf="s.studentImage" [src]="s.studentImage" alt="{{ s.studentName }}" />
        </div>
        <div class="st-list-text">
          <div class="st-list-title">{{ s.studentName }}</div>
          <div class="st-list-sub">{{ 'rollNo' | translate }}: {{ s.rollNumber }}</div>
          <div class="st-list-sub" *ngIf="isOnApprovedLeave(s)">{{ 'onApprovedLeave' | translate }}</div>
          <div class="st-list-sub" *ngIf="isOnPendingLeave(s)">{{ 'leaveRequestPending' | translate }}</div>
        </div>
        <div class="scd-status-btns">
          <button class="scd-status-btn present" [class.active]="s.Attendance === 'PRESENT'" (click)="markStatus(s, 'PRESENT')">{{ 'presentAbbrev' | translate }}</button>
          <button class="scd-status-btn absent" [class.active]="s.Attendance === 'ABSENT'" (click)="markStatus(s, 'ABSENT')">{{ 'absentAbbrev' | translate }}</button>
          <button class="scd-status-btn late" [class.active]="s.Attendance === 'LATE'" (click)="markStatus(s, 'LATE')">{{ 'lateAbbrev' | translate }}</button>
          <button class="scd-status-btn leave" *ngIf="isOnApprovedLeave(s)" [class.active]="s.Attendance === 'LEAVE'" (click)="markStatus(s, 'LEAVE')">{{ 'leaveAbbrev' | translate }}</button>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="sl-modal-overlay" *ngIf="showConfirmModal" (click)="cancelSubmitAttendance()">
    <div class="sl-modal" (click)="$event.stopPropagation()">
      <div class="sl-modal-icon"><i class="ri-checkbox-circle-line"></i></div>
      <h3 class="sl-modal-title">{{ 'markAttendanceHeading' | translate }}</h3>
      <p class="sl-modal-text">
        {{ 'confirmMarkAttendanceMessage' | translate }}<br />
        {{ 'attendanceWillBeRecordedAsOf' | translate }} {{ confirmDateLabel }} ({{ confirmTimeLabel }}).
      </p>
      <div class="sl-modal-actions">
        <button class="sl-modal-btn sl-modal-btn-secondary" [disabled]="submitting" (click)="cancelSubmitAttendance()">{{ 'no' | translate }}</button>
        <button class="sl-modal-btn sl-modal-btn-primary" [disabled]="submitting" (click)="confirmSubmitAttendance()">{{ 'yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>
